module.exports = __webpack_public_path__ + "static/media/img-login-bottomleft@2x.ce991fce.png";